import React from "react";
import { Fade } from "react-awesome-reveal";
import type { MainProfile } from "../../types/resume";

interface FooterProps {
  data?: MainProfile;
}

const Footer = ({ data }: FooterProps) => {
  if (!data) return null;

  return (
    <footer className="bg-gray-900 text-gray-300 pt-10 pb-6 relative">
      <div className="max-w-7x2 mx-auto px-6 flex flex-col md:flex-row justify-between items-center">
        {/* Social Links */}
        <Fade direction="up" duration={1000} triggerOnce>
          <div className="flex flex-col items-center mb-6 md:mb-0">
            <h3 className="text-orange-500 text-xl md:text-2xl font-semibold tracking-wide mb-4">
              FOLLOW US
            </h3>

            <ul className="flex space-x-8">
              {data.social.map((network) => (
                <li 
                key={network.name} className="relative flex items-center justify-center">
                  <a
                    href={network.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="peer text-sky-400 hover:text-orange-500 transition-all duration-300 text-3xl md:text-4xl transform hover:scale-110"
                  >
                    <i className={network.className}></i>
                  </a>
                  <div className="absolute -top-12 left-1/2 -translate-x-1/2 opacity-0 peer-hover:opacity-100 transition-all duration-300 text-sm font-bold text-slate-900 bg-white px-3 py-1 rounded-md shadow-lg pointer-events-none whitespace-nowrap transform translate-y-2 peer-hover:translate-y-0">
                  {network.name}
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-white rotate-45"></div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Fade>

        {/* Copyright */}
        <Fade direction="up" duration={1200} triggerOnce>
          <div className="text-center md:text-right text-sm md:text-base space-y-1">
            <p>&copy; 2025 Efwan Rizaldi. All rights reserved.</p>
            <p>
              Design by{" "}
              <a
                href="http://www.styleshout.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sky-400 hover:underline transition"
              >
                Styleshout
              </a>
            </p>
          </div>
        </Fade>
      </div>
    </footer>
  );
};

export default Footer;
